function getRequestParams(state, params = {}) {
  const requestParams = {
    ...params,
    search: state.searchText,
  };

  if (!state.orderParam.value) return requestParams;

  return {
    ...requestParams,
    OrderField: state.orderParam.value,
    OrderDirection: state.orderParam.direction,
  };
}

export const state = () => ({
  allItems: [],
  nextPage: 1,
  lastPage: false,
  numbersItems: 0,
  loading: false,
  orderParam: {
    value: "",
    direction: "desc",
  },
  searchText: "",
});

export const getters = {
  getItems: (state) => state.allItems,

  getLastPage: (state) => state.lastPage,

  getNumbersItems: (state) => state.numbersItems,

  getLoading: (state) => state.loading,

  getOrderValue: (state) => state.orderParam.value,

  getOrderDirection: (state) => state.orderParam.direction,

  getSearchText: (state) => state.searchText,
};

export const mutations = {
  setItems: (state, items) => {
    state.allItems = items;
  },

  addItems: (state, items) => {
    for (let item of items) {
      state.allItems.push(item);
    }
  },

  setNumbersItems: (state, numbers) => {
    state.numbersItems = numbers;
  },

  setNextPage: (state, number) => {
    state.nextPage = number;
  },

  setLastPage: (state, value) => {
    state.lastPage = value;
  },

  setLoading: (state, value) => {
    state.loading = value;
  },

  removePhotosFromItem: (state, { itemId, photoIds }) => {
    const photoIdSet = new Set(Array.isArray(photoIds) ? photoIds : [photoIds]);
    const item = state.allItems.find((i) => i.id === itemId);
    if (!item) return;

    const remaining = item.photos.filter((p) => !photoIdSet.has(p.id));

    if (remaining.length === 0) {
      state.allItems = state.allItems.filter((i) => i.id !== itemId);
      state.numbersItems = Math.max(0, state.numbersItems - 1);
    } else {
      state.allItems = state.allItems.map((i) =>
        i.id === itemId ? { ...i, photos: remaining } : i
      );
    }
  },

  updateItemValidated: (state, { itemId, validated }) => {
    state.allItems = state.allItems.map((i) =>
      i.id === itemId ? { ...i, validated } : i
    );
  },

  setOrderValue: (state, value) => {
    state.orderParam.value = value;
  },

  setOrderDirection: (state, value) => {
    state.orderParam.direction = value;
  },

  setSearchText: (state, text) => {
    state.searchText = text;
  },
};

export const actions = {
  async retrieveItems({ state, commit }, payload = "new-photos-block") {
    try {
      if (payload.includes("new")) {
        payload = "";
      } else {
        payload = payload.split("-")[0];
      }

      commit("setLoading", true);

      let {
        profiles_photo: items,
        page: currentPage,
        total: numbers,
        number_pages,
      } = await this.$axios.$get(
        `/api/photos/manager/get${!payload.length ? "" : "/" + payload}?page=1`,
        {
          params: getRequestParams(state),
        }
      );

      if (currentPage < number_pages) {
        commit("setLastPage", false);
      } else {
        commit("setLastPage", true);
      }

      commit("setItems", items);
      commit("setLoading", false);
      commit("setNextPage", ++currentPage);
      commit("setNumbersItems", numbers);
    } catch (error) {
      console.log(error);

      commit("setItems", []);
    }
  },

  async retrieveNextItems({ state, commit }, payload) {
    try {
      let {
        profiles_photo: items,
        page: currentPage,
        total: numbers,
        number_pages,
      } = await this.$axios.$get(
        `/api/photos/manager/get${
          payload && payload.length ? "/" + payload : ""
        }`,
        {
          params: getRequestParams(state, {
            page: state.nextPage,
          }),
        }
      );

      if (currentPage < number_pages) {
        commit("setLastPage", false);
      } else {
        commit("setLastPage", true);
      }

      commit("addItems", items);
      commit("setNextPage", ++currentPage);
      commit("setNumbersItems", numbers);
    } catch (error) {
      console.log(error);

      commit("setItems", []);
    }
  },
};
